<template>
  <div v-title :data-title="'卓考网校|' + courseName + '|知识点'">
    <main class="g-view-container">
      <swiper v-if="knowList.length" :options="swiperOption">
        <swiper-slide v-for="(item, index) in knowList" :key="item.knowledgeId">
          <h4 class="title">【考点 {{ index + 1 }}】{{ item.title }}</h4>
          <div class="body">
            <div class="sub-title">重点：{{ item.subTitle }}</div>
            <p class="content" v-html="item.content"></p>
          </div>
        </swiper-slide>
      </swiper>

      <div class="swiper-button">
        <div class="swiper-button-prev">上一个</div>
        <div class="swiper-button-next">下一个</div>
      </div>
    </main>
  </div>
</template>

<script>
  import Course from 'models/course';

  export default {
    name: 'knowSample',
    data() {
      return {
        courseId: this.$route.params.courseId,
        knowList: [],
        swiperOption: {
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
      };
    },
    created() {
      this.courseName = Course.getCourseName(this.courseId);
      this.showLoading();
      Promise.all([this.getKnowList(1), this.getKnowList(2)]).then((res) => {
        this.hideLoading();
        this.knowList = res[0].concat(res[1]).slice(0, 5);
      });
    },
    methods: {
      getKnowList(chapterNo) {
        return new Promise((resolve) => {
          this.axios
            .get(
              `https://cbt.tibaitong.com/courseChapter/getChapterContent?courseId=${this.courseId}&chapterNo=${chapterNo}`,
            )
            .then((res) => {
              if (res.data.code === 200) {
                resolve(res.data.data);
              }
            });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.g-view-container {
  position: relative;
}

.swiper-container {
  height: calc(100% - 50px);

  .swiper-slide {
    height: 100%;
    padding: 0 15px;
    @include flex-between(column);

    .title {
      width: 100%;
      margin: 25px 0 15px 0;
      font-size: $font-size-l;
      color: $theme-color;
    }

    .body {
      flex: 1;
      width: 100%;
      padding: 20px;
      background-color: #fff;
      border-radius: 8px;
      overflow: scroll;
    }

    .sub-title {
      margin-bottom: 20px;
      color: #333;
      font-weight: bold;
    }

    .content {
      font-size: $font-size-l;
      line-height: 2;
    }
  }
}

.swiper-button {
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 30px;
  @include flex-between();
  justify-content: space-evenly;

  .swiper-button-prev {
    position: static;
    width: 120px;
    height: 40px;
    font-size: $font-size-l;
    color: #fff;
    text-align: center;
    line-height: 40px;
    border-radius: 4px;
    background: none;
    background-color: #fec24f;
  }

  .swiper-button-next {
    @extend .swiper-button-prev;
    background-color: $theme-color;
  }
}
</style>
